module.exports = __webpack_public_path__ + "img/Graficosweb.121b6ce4.png";